import React from "react";
import {useForm} from "react-hook-form";
import {Container, Step, StepContent, StepLabel, Stepper} from "@mui/material";
import Step1 from "./editScheduleStepper/Step1";
import Step2 from "./editScheduleStepper/Step2";
import Step3 from "./editScheduleStepper/Step3";
import Step4 from "./editScheduleStepper/Step4";

export default function EditScheduleStepper(props) {
  const loadParams = (nm) => {
    return sessionStorage.getItem(nm) || "";
  };
  // const saveParams = (nm, val) => {
  //   return sessionStorage.setItem(nm, val);
  // };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  const {control, getValues, register, unregister, setValue} = useForm();
  const [state, setState] = React.useState({
    activeStep: parseInt(loadParams("activeStep")) || 0
  });
  const steps = [
    [
      "サービス種類",
      <Step1
        control = {control}
        errorFunc = {props.errorFunc}
        getValues = {getValues}
        propState = {props.state}
        register = {register}
        setPropState = {props.setState}
        setState = {setState}
        setValue = {setValue}
        state = {state}
      />
    ],
    [
      "サービス条件",
      <Step2
        control = {control}
        errorFunc = {props.errorFunc}
        getValues = {getValues}
        propState = {props.state}
        register = {register}
        unregister = {unregister}
        setPropState = {props.setState}
        setState = {setState}
        setValue = {setValue}
        state = {state}
      />
    ],
    [
      "基本サービス",
      <Step3
        control = {control}
        errorFunc = {props.errorFunc}
        getValues = {getValues}
        propState = {props.state}
        register = {register}
        unregister = {unregister}
        setPropState = {props.setState}
        setState = {setState}
        state = {state}
      />
    ],
    [
      "内容の確認",
      <Step4
        control = {control}
        errorFunc = {props.errorFunc}
        getValues = {getValues}
        propState = {props.state}
        register = {register}
        setPropState = {props.setState}
        setState = {setState}
        setToastState = {props.setToastState}
        state = {state}
        toastState = {props.toastState}
      />
    ]
  ];

  React.useEffect(() => {
    window.addEventListener("beforeunload", (e) => {
      saveJson("editScheduleStepper", getValues());
    });
    if (Boolean(loadParams("editScheduleStepper"))) {
      Object.keys(loadJson("editScheduleStepper")).map((data) => (
        setValue(data, loadJson("editScheduleStepper")[data])
      ));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      sx = {{p: 0}}
    >
      <Stepper
        activeStep = {state.activeStep}
        orientation = "vertical"
      >
        {steps.map((step, i) => (
          <Step
            key = {"step" + i}
          >
            <StepLabel>
              {step[0]}
            </StepLabel>
            <StepContent
              sx = {{pl: 1, pr: 1}}
            >
              {step[1]}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Container>
  );
};
